import { BoldTextM, Breakpoint, TableRowModel } from "@enxcs/dap-ui-stratos";
import { AttendeeListItem } from "@/models/prepareRecording";
import { formatAttendeeName } from "./formatters";

export const filterAttendeeItems = (attendees: AttendeeListItem[], filterKey: string) => {
  const normalizedFilterKey = filterKey.trim().toLowerCase();

  return attendees.filter((attendee) => {
    if (!normalizedFilterKey) {
      return true;
    }

    const searchText = [formatAttendeeName(attendee.name)].filter(Boolean).join(" ").toLowerCase();

    return searchText.includes(normalizedFilterKey);
  });
};

export const createAttendeesTableRows = (attendees: AttendeeListItem[], selectedAttendeeIds: string[]): TableRowModel[] => {
  return attendees.map((attendee) => {
    return {
      key: attendee.id,
      select: selectedAttendeeIds.includes(attendee.id),
      value: attendee.id,
      cells: [{ content: <BoldTextM>{formatAttendeeName(attendee.name)}</BoldTextM>, breakpoint: Breakpoint.M }],
    };
  });
};
